/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.parse-float.js";
// import mockData from './mockData.json';
import F2 from '@antv/f2/lib/index-all';
import Overlay from '@/components/Overlay.vue';
import { getFactorySaleStoneData } from '@/service/production/StoneSaleRank';
export default defineComponent({
  name: 'StoneSaleRank',
  components: {
    Overlay: Overlay
  },
  setup: function setup() {
    var contentRef = ref();
    var data = ref([]);
    var chart = ref(null);
    var dataStatus = ref(true);
    var tableData = ref([]);
    var showOverlay = ref(false);
    function sendConHeight() {
      setTimeout(function () {
        var contentHeight = contentRef.value.offsetHeight;
        console.log(contentHeight, 'aaa');
        // eslint-disable-next-line no-undef
        Android.sendHeight(contentHeight);
      }, 50);
    }
    function renderChart(params) {
      chart.value.clear();
      // const data = params.slice();
      data.value = params.stone_num_data || [];
      var weightArr = data.value.map(function (item) {
        return parseFloat(item.value);
      });
      var totalWeight = _.sum(weightArr);
      // showAlertInfo('饼图==', data.value);
      if (!_.isEmpty(data.value)) {
        data.value.map(function (item) {
          item.const = 'const';
          // item.num = Number(item.value);
          // const str = item.ratio_num;
          item.value = parseFloat(item.value);
          item.list = item.customerSaleStoneData;
          item.rate = _.round(item.value / totalWeight * 100, 2);
        });
        dataStatus.value = true;
        chart.value.source(data.value);
        chart.value.coord('polar', {
          transposed: true,
          radius: 0.6,
          innerRadius: 0.6
        });
        chart.value.axis(false);
        chart.value.legend(false);
        chart.value.tooltip(false);
        chart.value.guide().html({
          position: ['50%', '50%'],
          html: '<div style="text-align: center; width:150px; height: 50px;">\n      <p style="font-size: 12px;color: #999;margin: 0" id="title"></p>\n      <p style="font-size: 18px;color: #343434;margin: 0;font-weight: bold;" id="money"></p>\n      <p style="font-size: 14px;color: #666;margin: 0;font-weight: bold;" id="rate"></p>\n   </div>'
        });
        chart.value.interval().position('const*value').adjust('stack').color('name', ['#6AECFF', '#00D975', '#5D7092', '#FFC900', '#F3596B', '#00B2F4', '#A285D2', '#FF9D4D', '#269A99', '#FF99C3', '#1E3370']);
        chart.value.pieLabel({
          sidePadding: 10,
          activeShape: true,
          label1: function label1(data) {
            return {
              text: data.value + '吨' + ' ' + data.rate + '%',
              fill: '#343434',
              fontWeight: 'bold'
            };
          },
          label2: function label2(data) {
            return {
              text: data.name,
              fill: '#999'
            };
          },
          onClick: function onClick(ev) {
            var data = ev.data;
            if (data) {
              document.getElementById('title').innerText = data.name;
              document.getElementById('money').innerText = data.value + '吨';
              document.getElementById('rate').innerText = data.rate + '%';
              try {
                tableData.value = data.list;
                // console.log('tableData.value=>', tableData.value);
                // eslint-disable-next-line no-undef
                Android.sendData(JSON.stringify(data.list));
              } catch (e) {
                console.log('e=>', e);
              }
            }
          }
        });
        chart.value.render();
      } else {
        dataStatus.value = false;
        return false;
      }
    }
    function getFactorySaleStoneDataAndRender() {
      return _getFactorySaleStoneDataAndRender.apply(this, arguments);
    }
    function _getFactorySaleStoneDataAndRender() {
      _getFactorySaleStoneDataAndRender = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _data, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              showOverlay.value = true;
              _context2.next = 4;
              return getFactorySaleStoneData();
            case 4:
              _data = _context2.sent;
              result = _data;
              renderChart(result);
            case 7:
              _context2.prev = 7;
              showOverlay.value = false;
              return _context2.finish(7);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0,, 7, 10]]);
      }));
      return _getFactorySaleStoneDataAndRender.apply(this, arguments);
    }
    onMounted(function () {
      nextTick( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              chart.value = new F2.Chart({
                id: 'container',
                pixelRatio: window.devicePixelRatio
              });
              getFactorySaleStoneDataAndRender();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
      window.renderChart = renderChart;
    });
    return {
      tableData: tableData,
      contentRef: contentRef,
      dataStatus: dataStatus,
      showOverlay: showOverlay,
      sendConHeight: sendConHeight
    };
  }
});